import { render, staticRenderFns } from "./ClinicServices.vue?vue&type=template&id=bcd82358&scoped=true&"
import script from "./ClinicServices.vue?vue&type=script&lang=js&"
export * from "./ClinicServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd82358",
  null
  
)

export default component.exports